// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"21ff71ce","433":"7e561537","787":"b0b31fd9","811":"5bf6d606"}[chunkId] + ".chunk.js";
};